import {Text, View} from "react-native";
import * as React from "react";

export const SectionTitle = ({children}) => <View style={{flexWrap: 'wrap', marginBottom: 10, marginTop: 50}}>
    <View style={{
        padding: 0,
        height: 26,
        paddingLeft: 5,
        paddingRight: 25,
        fontSize: 16,
        backgroundColor: '#a0ca45',
        color: 'white',
        borderTopRightRadius: 13,
        borderBottomRightRadius: 13,
        justifyContent: 'center'

    }}>
        <Text style={{ color: 'white', fontSize:16 }}>{children}</Text>
    </View>
</View>